import KeenSlider from "keen-slider";

class HeroSlider extends HTMLElement {
  constructor() {
    super();
    // Parse attributes from Liquid
    this.autoplayDelay = parseInt(this.dataset.autoplayDelay) || 5000;
    this.transitionDuration = parseInt(this.dataset.transitionDuration) || 1000;
    this.showIndicators = this.dataset.showIndicators === 'true';

    this.slider = null;
    this.indicators = null;
  }

  connectedCallback() {
    this.initSlider();
  }

  initSlider() {
    // Import Keen Slider if needed (assuming it's loaded globally or via module)
    // const { default: KeenSlider } = await import('keen-slider/keen-slider.esm.js');

    const slides = this.querySelectorAll('.keen-slider__slide img');
    let loadedCount = 0;
    const totalImages = slides.length;

    const onImageLoad = () => {
      loadedCount++;
      if (loadedCount === totalImages) {
        this.initializeKeenSlider();
      }
    };

    // Check for already loaded images (e.g., cached)
    slides.forEach(img => {
      if (img.complete) {
        onImageLoad();
      } else {
        img.addEventListener('load', onImageLoad);
        img.addEventListener('error', onImageLoad); // Handle errors to avoid hanging
      }
    });

    // Fallback: Init anyway after a timeout if loads fail
    if (totalImages === 0) {
      this.initializeKeenSlider();
    } else {
      setTimeout(() => {
        if (loadedCount < totalImages) {
          this.initializeKeenSlider(); // Force init if timeout
        }
      }, 5000); // Adjust timeout as needed
    }
  }

  initializeKeenSlider() {
    this.slider = new KeenSlider(this.querySelector('.keen-slider'), {
      loop: true, // Assuming loop based on gallery
      duration: this.transitionDuration,
      slides: { perView: 1, spacing: 0 },
      // Add autoplay if desired
      created: () => {
        // Init indicators if shown
        if (this.showIndicators) {
          this.setupIndicators();
        }
      },
      slideChanged: (slider) => {
        // Update indicators
        if (this.showIndicators) {
          this.updateIndicators(slider.track.details.rel);
        }
      }
    });

    // Autoplay logic
    let timeout;
    const autoplay = () => {
      clearTimeout(timeout);
      timeout = setTimeout(() => this.slider.next(), this.autoplayDelay);
    };
    this.slider.on('dragStarted', () => clearTimeout(timeout));
    this.slider.on('animationEnded', autoplay);
    this.slider.on('updated', autoplay);
    autoplay(); // Start
  }

  setupIndicators() {
    this.indicators = this.querySelectorAll('.keen-indicator');
    this.indicators.forEach((indicator, index) => {
      indicator.addEventListener('click', () => this.slider.moveToIdx(index));
    });
    this.updateIndicators(0); // Initial
  }

  updateIndicators(currentIdx) {
    this.indicators.forEach((indicator, index) => {
      indicator.classList.toggle('bg-white/60', index === currentIdx);
      indicator.classList.toggle('bg-white/40', index !== currentIdx);
    });
  }
}

customElements.define('hero-slider', HeroSlider);
